import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CommunicationComposeModalFormComponent } from '../communication-compose-modal-form/communication-compose-modal-form.component';
import { CommunicationDTO } from 'src/app/core/models/system/communication/communication.dto';
import { CommunicationsEmbeddedComponent } from 'src/app/pages-embedded/communications/communications.component';
import { CommunicationModalFormComponent } from '../communication-modal-form/communication-modal-form.component';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';

@Component({
  selector: 'app-communication-grid-modal-form',
  templateUrl: './communication-grid-modal-form.component.html',
  styleUrls: ['./communication-grid-modal-form.component.scss']
})

export class CommunicationGridModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild('communicationComposeModalForm', { static: false }) communicationComposeModalForm!: CommunicationComposeModalFormComponent;
  @ViewChild('communicationGridModalForm',    { static: false }) communicationGridModalForm!   : TemplateRef<void>;
  @ViewChild('communicationModalForm',        { static: false }) communicationModalForm!       : CommunicationModalFormComponent;
  @ViewChild('communicationsEmbedded',        { static: false }) communicationsEmbedded!       : CommunicationsEmbeddedComponent;
  @ViewChild('replyModalForm',                { static: false }) replyModalForm!               : CommunicationModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                          
  private communicationGridModalFormRef!: NgbModalRef;
  private communicationModalFormIsOpen  : boolean=false;

  public curUser         : SystemUserDTO;
  public formTitle       : string="Received Messages";
  public replyToCompanyId: number | undefined;
  public replyToUserId   : number | undefined;
  public showComposeForm : boolean=false;

  constructor(
    private authenticationService: AuthenticationService,
    private changeDetectorRef    : ChangeDetectorRef,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.communicationModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(): void {
    try {
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openMessage(communicationId: number): void {
    try {
      if (!this.communicationModalFormIsOpen) {
        this.communicationModalFormIsOpen=true;
        this.communicationModalForm.openForm(communicationId, true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.communicationGridModalFormRef=this.modalService.open(this.communicationGridModalForm, { backdrop: this.modalBackGround, 
                                                                                                   centered: true,
                                                                                                   keyboard: false,
                                                                                                   size    : msSize.ExtraLarge });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public communicationFormCancel() {
    try {
      this.communicationGridModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridAddButtonClick(e: any){
    try {
      if (!this.communicationModalFormIsOpen) {
        this.communicationModalFormIsOpen=true;

        this.showComposeForm=true;
        this.changeDetectorRef.detectChanges();
        this.communicationComposeModalForm.openForm();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridEditButtonClick(communication: CommunicationDTO){
    try {
      if (!this.communicationModalFormIsOpen) {
        this.communicationModalFormIsOpen=true;
        this.communicationModalForm.openForm(communication.id, true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public communicationDataHasBeenSaved(communicationId: number | undefined) {
    try {
      this.communicationModalFormIsOpen=false;

      if (communicationId != undefined && <number>communicationId>0) {
        this.communicationsEmbedded?.gridView?.refreshData(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public communicationFormHasBeenCancelled() {
    try {
      this.communicationModalFormIsOpen=false;
      this.communicationsEmbedded?.gridView?.refreshData(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public communicationFormOnOpenReply(data: { companyId: number, userId: number }) {
    try {
      this.showComposeForm=true;
      this.changeDetectorRef.detectChanges();
      this.communicationComposeModalForm.openForm(data.companyId, data.userId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
